import type { MouseEvent } from "react";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";
import type { CourseTemplate } from "../../providers/courseTemplatesProvider";

export function CourseTemplateMobileListItem(props: {
  courseTemplate: CourseTemplate;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { courseTemplate, onClick } = props;
  const theme = useTheme();
  const modules = courseTemplate.modules.map((module) => module.name).join(", ");

  return (
    <ButtonBase
      component="div"
      onClick={onClick}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
          {courseTemplate.name}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
          {modules}
        </Typography>
      </Column>
    </ButtonBase>
  );
}
